import { Navigate, Outlet } from "react-router-dom";

export default function AdminRoute() {
  const admin = localStorage.getItem("admin");

  // Verifica se é nulo, undefined ou uma string "undefined"
  if (!admin || admin === "undefined") {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
